import React, { useState, useEffect } from "react";
import '../../landing/styles/custom.css'
import '../../landing/styles/globals.css'
import '../../landing/styles/index.css'
import { CompactHeader } from "../../landing/components/CompactHeader";
import { EventPhotosHero } from "../../landing/components/EventPhotosHero";
import { ServicesSection } from "../../landing/components/ServicesSection";
import { FeaturedSection } from "../../landing/components/FeaturedSection";
import { NewsSection } from "../../landing/components/NewsSection";
import { Footer } from "../../landing/components/Footer";
import { Toaster } from "../../landing/components/ui/sonner";
import * as Constants from '../../constants';
import PdfViewer from "../../components/controls/pdfviewer";
import JisDialogForm from "../../components/formdialog";
const PDF_URL = `${Constants.baseurl}/assets/landing_images/filingdetails.pdf`; 

export default function LandingNew() {
  const [darkMode, setDarkMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); 
  const [pdfUrl, setPdfUrl] = useState(''); // State to hold the PDF URL


  // Initialize dark mode from localStorage or system preference
  useEffect(() => {
    //setIsModalOpen(true);
    checkNotice();
    const savedMode = localStorage.getItem("darkMode");
    if (savedMode) {
      setDarkMode(JSON.parse(savedMode));
    } else {
      // Check system preference
      setDarkMode(window.matchMedia("(prefers-color-scheme: dark)").matches);
    }
  }, []);

  const checkNotice = async () => {
      try {
        const response = await fetch(
          `${Constants.apiUrl}/cms/notice-link`
        );
  
        if (response.ok) {
          const data = await response.json();
          setPdfUrl(data.link);
          setIsModalOpen(true);
        } else {
          setPdfUrl('');
        }
      } catch (error) {
        console.error("Error checking notice:", error);
        setPdfUrl('');
      }
    };


  // Apply dark mode class to document
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode((prev) => !prev);
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 overflow-x-hidden">
      {/* Navigation Header */}
      <CompactHeader darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

      {/* Main Content */}
      <main className="relative">
        {/* Event Photos Hero Section */}
        <EventPhotosHero />

        {/* Services Grid */}
        <ServicesSection />

        {/* Featured Content */}
        <FeaturedSection />

        {/* News & Updates */}
        <NewsSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Toast Notifications */}
      <Toaster position="top-right" richColors closeButton />
       {isModalOpen && pdfUrl!='' && <JisDialogForm title="Public Notice" onClose={() =>setIsModalOpen(false)} height="70vh">
                <div>
                  <div style={{height:'90vh'}}> <PdfViewer pdfUrl={pdfUrl}/>
                                     
                                      </div>
                </div></JisDialogForm>}
      
      
    </div>
  );
}
